import SVRStatBlocks from './SVRStatBlocks';

export default SVRStatBlocks;
